import {getAssetUrl} from '@common/utils/urls/get-asset-url';

export type ImageSize = 'sm' | 'md' | 'lg' | 'original';

interface Options {
  size?: ImageSize;
}

export function useImageSrc(
  src: string | undefined,
  {size}: Options = {}
): string | undefined {
  if (!src) return;
  if (!size) size = 'original';

  if (isSizeSegmentBased(src)) {
    return getSegmentBasedSrc(src, size);
  }

  return `${getLocalSrc(getAssetUrl(src), size)}`;
}

export function useImageSrcSet(src: string | undefined): string | undefined {
  if (!src) return;

  if (isSizeSegmentBased(src)) {
    return `${src.replace(/original|w1280/, 'w300')} 768w, ${src.replace(
      /original|w1280/,
      'w780'
    )} 1024w, ${src.replace(/original|w1280/, 'w1280')} 1280w`;
  }

  return `${src.replace(/original/, 'small')} 768w, ${src.replace(
    /original/,
    'medium'
  )} 1024w, ${src.replace(/original/, 'large')} 1280w`;
}

// Images served from an image CDN use a /t/p/<size>/<file> path where the
// size is a path segment (w92, w300, w500, original etc), as opposed to
// locally stored images which encode the size as a filename prefix.
function isSizeSegmentBased(src: string): boolean {
  return src.includes('/t/p/');
}

function getSegmentBasedSrc(initialSrc: string, size: ImageSize): string {
  switch (size) {
    case 'sm':
      return initialSrc.replace(/original|w1280/, 'w92');
    case 'md':
      return initialSrc.replace(/original|w1280/, 'w300');
    case 'lg':
      return initialSrc.replace(/original|w1280/, 'w500');
    default:
      return initialSrc;
  }
}

function getLocalSrc(initialSrc: string, size: ImageSize): string {
  switch (size) {
    case 'sm':
      return initialSrc.replace('original', 'small');
    case 'md':
      return initialSrc.replace('original', 'medium');
    case 'lg':
      return initialSrc.replace('original', 'large');
    default:
      return initialSrc;
  }
}
